import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { avatarListClasses } from "./AvatarList";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { Box } from "./Box";
export const iconAvatarClasses = {
    root: "MinervaIconAvatar-root",
};
export const IconAvatar = memo(forwardRef((props, ref) => {
    const { size = "md", color = "primary", colorSet = "container", invertColors, className, sx, ...rest } = useDefaultProps({ component: "IconAvatar", props });
    const sizing = {
        xxs: 6,
        xs: 6.5,
        sm: 8,
        md: 10,
        lg: 14,
        xl: 18,
    };
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: (colorStyles) => (_jsx(Box, { ref: ref, className: clsx([
                iconAvatarClasses.root,
                avatarListClasses.avatar,
                className,
            ]), sx: mergeSx({
                ...colorStyles,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: typeof size === "number" ? size : sizing[size],
                height: typeof size === "number" ? size : sizing[size],
                borderRadius: (theme) => theme.radius.full,
            }, sx), ...rest })) }));
}));
//# sourceMappingURL=IconAvatar.js.map